define('app/shared/selections/selectionsDirective.js',["https://cdnjs.cloudflare.com/ajax/libs/d3/3.5.12/d3.js"], function (d3) {
	function selectionsDirective() {
		return {
			restrict: 'E',
			replace: false,
			// scope: {data: '=chartData'},
			templateUrl: 'app/shared/selections/selections.html',
			link: function(scope, element, attrs) {
				
				// scope.$watchCollection('currentSelections', function(data) {
				// 	console.log(data);
				// });
				scope.clear = function (selection) {
					app.field(selection.qField).clear();
				}
				scope.clearAll = function () {
					app.clearAll();
				}

			}
		}
	}

  	return selectionsDirective;
});
